import React from "react";
import {
    PaymentType
} from "../UIHelpers";

export const PaymentTypeColumnFormatter = (cellContent, row) => (
    PaymentType[row.paymentType]
);
